import React from "react";
import ArrowCircle from "../../../btn/buttonCustom";
import Image from "next/image";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
export default function index({
  link,
  bgColor,
  projectName,
  lineColor,
  img,
  colorAfter,
  slug,
}) {
  const router = useRouter();
  const t = useTranslations("projects");
  const name = projectName.split(" ");
  return (
    <>
      <div
        className={` group relative projectName project max-w-[700px] container  md:h-[245px] h-[170px] cursor-pointer	 `}
        onClick={() => {
          router.push(`${slug}`);
        }}
      >
        <div
          className={` ${
            router.locale == "en" ? "button" : "rotate-180"
          }  button w-full h-full `}
        ></div>
        <div
          className={` flex flex-col justify-start text h-full z-[50] top-0 absolute  pt-[25px] ${
            router.locale == "en" ? "pl-[30px]" : "pr-[15px]"
          }  xl:px-[51px]`}
        >
          <p
            dangerouslySetInnerHTML={{ __html: projectName }}
            className="text-white leading-[35px] xlg:leading-[45px]  text-[24px] sm:text-[28px]  xl:text-[40px] mds:flex mds:items-center  font-[600]"
          />
          <hr
            style={{ backgroundColor: `${lineColor}` }}
            className={`p-[1.5px] md:p-[2.5px] border-none ${
              name.includes("<br/>") && router.locale == "en"
                ? "mt-[5px] md:mt-[15px]"
                : name.includes("<br/>") && router.locale == "ar"
                ? "mt-[25px]"
                : "mt-[15px]"
            } rounded-[22.5px]  w-[106px] md:w-[138px]`}
          />
          <div className="md:flex items-end mb-[44px] h-full hidden ">
            <div className="flex items-center justify-center z-[60]">
              <ArrowCircle
                href={`${slug}`}
                txt={t("Discover_More")}
                dark={false}
                bgColor={lineColor}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            right: router.locale == "ar" ? "" : "0px",
            left: router.locale == "ar" ? "0px" : "",
          }}
          className="absolute bottom-0"
        >
          <div className="md:h-[288px] md:w-[270px] h-[145px] w-[143.07px] xlg:group-hover:w-[300px] xlg:group-hover:h-[300px]  relative bottom-0 right-0  transition-all z-[50] ">
            <Image src={img} layout="fill" />
          </div>
        </div>
        <style jsx>{`
          .button {
            position: relative;
            border-radius: 15px;
            z-index: 1;
            background: ${bgColor};
          }
          .button:after {
            border-radius: 15px;
            position: absolute;
            content: "";
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: opacity 0.5s ease-out;
            z-index: -2;
            opacity: 0;
            background: ${colorAfter};
          }
          .text:hover + button:hover,
          .group:hover .button:after {
            opacity: 1;
          }
        `}</style>

        <div className="  overflow-hidden  z-10 w-full h-full absolute top-0">
          <div className="bg-[#ffffff1a] w-[24.78px] h-[573.63px] rotate-[-45deg] left-[-250px]   group-hover:translate-x-[1100px] tranform ease-in-out duration-700  absolute top-[-150px] "></div>
          <div className="bg-[#ffffff1a] w-[130.11px] h-[573.63px] rotate-[-45deg] left-[-250px]    group-hover:translate-x-[1100px] tranform ease-in-out duration-700  absolute top-[-150px] "></div>
        </div>
      </div>
    </>
  );
}
